import "normalize.css"

console.log("Hello, Gatsby!")
